module.exports = __webpack_public_path__ + "static/media/ces-family.2fadd4a1.png";